import React from 'react';
import { Box, Card, CardContent, Grid, Typography } from '@mui/material';
import ScheduleButton from './ScheduleButton';

const Testimonials = () => {
    const testimonials = [
        {
            name: 'William A. - Maryland',
            feedback:
                "My relationship was basically done, it was down a drain. We were friends/enemies living under the same roof. I realized that there were a lot of things that I had to fix myself that were causing a lot of issues. When you and I had our first conversation, I told you that I was all in. I was gonna do whatever it took. I knew she needed somebody that she could trust and that she could feel safe with. I basically started over at the foundation and built it back up. We've made a 180 turnaround. I've stepped up and I'm helping out around the house and with my son. And now her attitude has change tremendously. She used to be angry all the time. Now she's happier and not as stressed out. If you had asked me when we first talked if this was gonna happen, I couldn't have imagined that it would have. It's been an unbelievable experience. Unbelievable!",
        },
        {
            name: 'Edwin W. - Florida',
            feedback:
                "When I first started working with you, she had just brought up divorce. She was just fed up, disappointed that I wasn't stepping up. She had checked out for quite some time. She told me the famous words: I love you, but I'm not in love with you. She found the papers, printed them up, and signed them. I didn't want a divorce but I didn't know how to be the man she needed me to be. Working with you has given me the guidance to consistently step up and be that leader that God called me to be. None of this is easy, but it has been worth putting in the effort because we've been able to turn things around which feels fantastic!  Don't focus on winning her back. Focus on becoming a better version of you and the rest will follow. With your guidance, I don't see how anybody could fail.",
        },
        {
            name: 'Cooper T. - Texas',
            feedback:
                "Initially I was interested in the program because I wanted to work it out with the wife. And I felt like this was gonna give me answers, this was gonna show me what to do to get her back. But I was concerned that it would just be a waste of money because I knew that without the right support I would just shut down and do nothing. As I got into the program and Nick held my feet to the fire, I realized that I needed to stop chasing the relationship and just focus on myself. And that's when everything changed for me. After going through the program, the best parts have been seeing the growth with me and being able to get closer with the Lord. Now I'm able to control my reactions a lot more. I'm not letting my emotions just flow out and just lose it. I don't let her actions control my reactions, and man, it's just peaceful, this is amazing! It's the best money I spent! I feel so much better about it. I just feel peaceful.",
        },
        {
            name: 'Nick B. - Maine',
            feedback:
                "I was just so done... there was nothing exciting about life... I was done. Done being miserable. That's what made me join. Now I can be me... I just feel comfortable now. I'm me again... And it feels great! It's worth every penny, it's 100% worth it. I'm so happy. I really am. I can't stress it enough, I have a great, healthy relationship now, and I'm just so happy!",
        },
        {
            name: 'Tommy V. - New York',
            feedback:
                "It works! Just do it! I was dealing with a lot of anxiety in my relationship and I was worried about losing her. She is very stubborn and tough to deal with. After going through the process with Nick, I can handle things a lot better with her. I'm no longer defensive and can keep my cool. I feel real good and know that we can make this work.",
        },
        {
            name: 'E. Pashley - Ireland',
            feedback:
                "When I started with Nick, I was tired of repeating negative behavior and I wanted to change. The process works. You have to give it time knowing that you'll get the end result by trusting the process. I'm really proud of myself. Nick's even temperament helped me regulate and absorb the course material in a meaningful way, which I really appreciate.",
        },
        {
            name: 'Gabriel R. - California',
            feedback:
                "When I contacted you, I was just kind of at the end of my rope. I knew that I needed to have some support of some sort. I knew this before, but it was like, the problem wasn't the relationship, it wasn't any of these things, the problem was me. I was tired of hitting the same walls, and traditional therapy hadn't really done much. Now I feel confident and our relationship feels stronger than ever. Getting a coach was what really changed things for me. I can't thank you enough, because it really has been a life-changing experience.",
        },
        {
            name: 'Cody D. - Texas',
            feedback:
                "When I started working with Nick, my wife was saying that I was wasting my energy. Within a few weeks, everything started getting better with us. I do the small things for her and still help out with everything. I'm there for her more than I was and we are actually opening up to each other a lot more. We spend more time together and talk everyday. I appreciate Nick's help and guidance through this difficult situation.",
        },
        {
            name: 'Seth M. - Indiana',
            feedback:
                'The frameworks Nick gave me provided hope for the future that I know I can build for myself and my family. Things are going in a very positive direction and I feel like for the first time in a long time that I really am in control of myself.',
        },
        {
            name: 'José F. - Florida',
            feedback:
                'Nick has an incredible knack for making me feel completely at home, laying the groundwork for what would be an incredible journey of personal development. His dedication to my growth was clear—he put together a personalized plan to help me evolve. He has an eye for seeing potential and knows exactly how to help us reach it.',
        },
        {
            name: 'Mark H. - California',
            feedback:
                'Nick was committed to my growth inside and outside. He understands the balance and work that is required to find fulfillment and success in all facets of life.',
        },
    ];

    return (
        <Box pt={12}>
            <Typography variant="h4" gutterBottom textAlign={'center'}>
                True Stories from Men Just Like You
            </Typography>
            <Box
                display={'flex'}
                justifyContent={'center'}
                alignItems={'center'}
            >
                <Typography
                    variant="body1"
                    textAlign={'center'}
                    maxWidth={'800px'}
                    pb={5}
                >
                    What you're about to read are true stories from men I've
                    coached who, just like you, started with the desire to build
                    the relationship they deserved. With the right guidance and
                    support, that desire has become their reality, and I
                    couldn't be more excited to share their experiences with you
                    below.
                </Typography>
            </Box>

            <Box
                textAlign={'center'}
                pb={5}
                pt={5}
                sx={{
                    backgroundColor: '#f2ece0',
                    backgroundImage: 'url(/images/bgdots.png)',
                }}
                display={'flex'}
                justifyContent="center"
            >
                <Box maxWidth={'900px'} alignItems={'center'}>
                    <Grid container spacing={2} alignItems="center">
                        {testimonials.map((testimonial, index) => (
                            <Grid
                                key={index}
                                item
                                md={12}
                                display={'flex'}
                                justifyContent={
                                    index % 2 === 0 ? 'flex-start' : 'flex-end'
                                }
                                textAlign={'left'}
                            >
                                <Card
                                    sx={{
                                        m: 1,
                                        maxWidth: '600px',
                                    }}
                                >
                                    <CardContent>
                                        <Typography
                                            variant="subtitle1"
                                            maxWidth={'540px'}
                                        >
                                            {testimonial.feedback}
                                        </Typography>
                                        <Typography variant="h6">
                                            {testimonial.name}
                                        </Typography>
                                    </CardContent>
                                </Card>
                            </Grid>
                        ))}
                    </Grid>
                </Box>
            </Box>

            <Typography variant="h4" gutterBottom textAlign={'center'} pt={5}>
                Ready to Add Your Own Story?
            </Typography>
            <Box display={'flex'} justifyContent={'center'}>
                <Typography
                    variant="body1"
                    maxWidth={'1080px'}
                    textAlign={'center'}
                >
                    You've just read about the incredible results of some of my
                    past clients, people who shared your same challenges. Their
                    journey from where you are to where you want to be started
                    with a single step, and for a short time, I'm excited to
                    offer that same opportunity to you. If you're ready to get
                    started, click the button below now to book your free
                    Renewed Relationship Session today.
                </Typography>
            </Box>
            <Box display={'flex'} justifyContent={'center'} py={5}>
                <ScheduleButton />
            </Box>
        </Box>
    );
};

export default Testimonials;
